import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { AppConfig } from 'src/assets/config/config/app-config';
// import { Category, CategoryNode, NewCategory } from '../_models';

@Injectable({ providedIn: 'root' })
export class FileInboxVirtualFolderService {
    apiUrl: string
    allVFolders = [];
    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig("apiUrl")
    }

    getTree(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + `/fileInbox/virtual-folder/tree`)
            .pipe()
    }

    getFolderTree(teamId): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + `/fileInbox/team/folder/tree/` + teamId)
            .pipe()
    }

    getAllVirtualFolders(){
        return this.http.get<any[]>(this.apiUrl + `/fileInbox/virtual-folder/all`)
            .pipe()
    }

    getFolderDetails(folderId): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/meta-data/` + folderId)
            .pipe(
            );
    }

    getDynamicForms(): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/dynamic-forms/get`)
            .pipe(
            );
    }

    getVirtualFolderCount(countFor, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/count?countFor=`+countFor +`&offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    async getFlattenedTree() {
        this.allVFolders = [];
        let folders = await this.http.get<any[]>(this.apiUrl + `/fileInbox/virtual-folder/tree`).toPromise()
        this.flattenVirtualFolder(folders);
        return  this.allVFolders
    }

    async getFlattenedFolderTree(teamId) {
        this.allVFolders = [];
        let folders = await this.http.get<any[]>(this.apiUrl + `/fileInbox/team/folder/tree/` + teamId).toPromise()
        this.flattenVirtualFolder(folders);
        return  this.allVFolders
    }

    private flattenVirtualFolder(folders) {
        for (let i = 0; i < folders.length; i++) {
            let tempFolder = folders[i];
            if (tempFolder['sub_folders']) {
                this.flattenVirtualFolder(tempFolder['sub_folders'])

                if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                    this.allVFolders.push(tempFolder);
                }
            } else {
                if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                    this.allVFolders.push(tempFolder)
                }
            }
        }
    }

    get(folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/` + folderId+`?offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    getDuplicate(folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/duplicate/` + folderId+`?offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    getTeamDuplicate(teamId, folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/duplicate/team/get/` + teamId+`?folderId=`+folderId+`&offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    getIndexDocuments(folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/virtual-folder/index/` + folderId+`?offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    getTeamIndexDocuments(teamId, folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/fileInbox/index/team/get/` + teamId+`?folderId=`+folderId +`&offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    createFolder(req: any): Observable<any> {
        return this.http.post(this.apiUrl + `/fileInbox/virtual-folder/create`, req).pipe(map(obj => obj),
            (catchError(this.errorHandler))

        )
    }

    updateFolder(req: any): Observable<any> {
        return this.http.put(this.apiUrl + `/fileInbox/virtual-folder/update`, req).pipe(map(obj => obj),
            (catchError(this.errorHandler))

        )
    }

    errorHandler(error: HttpErrorResponse) {
        return throwError(error);
    }
}

